export const bulkPrintProfileMax = 1000;
